import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Philosophy from './pages/Philosophy';
import ServicesRetail from './pages/ServicesRetail';
import ServicesCorporate from './pages/ServicesCorporate';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import BookSummaries from './pages/BookSummaries';
import BookSummaryDetail from './pages/BookSummaryDetail';
import BooksStore from './pages/BooksStore';
import Contact from './pages/Contact';
import SIPCalculator from './pages/calculators/SIPCalculator';
import SWPCalculator from './pages/calculators/SWPCalculator';
import RetirementCalculator from './pages/calculators/RetirementCalculator';
import FIRECalculator from './pages/calculators/FIRECalculator';
import GoalPlannerCalculator from './pages/calculators/GoalPlannerCalculator';
import EMICalculator from './pages/calculators/EMICalculator';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminChangePassword from './pages/admin/AdminChangePassword';
import AdminBlogs from './pages/admin/AdminBlogs';
import AdminBookSummaries from './pages/admin/AdminBookSummaries';
import AdminBooks from './pages/admin/AdminBooks';
import AdminContacts from './pages/admin/AdminContacts';
import AdminTestimonials from './pages/admin/AdminTestimonials';

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen bg-background">
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-right" richColors />
          <Routes>
          {/* Public Routes */}
          <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
          <Route path="/philosophy" element={<><Navbar /><Philosophy /><Footer /></>} />
          <Route path="/services/retail" element={<><Navbar /><ServicesRetail /><Footer /></>} />
          <Route path="/services/corporate" element={<><Navbar /><ServicesCorporate /><Footer /></>} />
          <Route path="/blogs" element={<><Navbar /><Blogs /><Footer /></>} />
          <Route path="/blogs/:slug" element={<><Navbar /><BlogDetail /><Footer /></>} />
          <Route path="/book-summaries" element={<><Navbar /><BookSummaries /><Footer /></>} />
          <Route path="/book-summaries/:slug" element={<><Navbar /><BookSummaryDetail /><Footer /></>} />
          <Route path="/books" element={<><Navbar /><BooksStore /><Footer /></>} />
          <Route path="/contact" element={<><Navbar /><Contact /><Footer /></>} />
          
          {/* Calculator Routes */}
          <Route path="/calculators/sip" element={<><Navbar /><SIPCalculator /><Footer /></>} />
          <Route path="/calculators/swp" element={<><Navbar /><SWPCalculator /><Footer /></>} />
          <Route path="/calculators/retirement" element={<><Navbar /><RetirementCalculator /><Footer /></>} />
          <Route path="/calculators/fire" element={<><Navbar /><FIRECalculator /><Footer /></>} />
          <Route path="/calculators/goal" element={<><Navbar /><GoalPlannerCalculator /><Footer /></>} />
          <Route path="/calculators/emi" element={<><Navbar /><EMICalculator /><Footer /></>} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/change-password" element={<AdminChangePassword />} />
          <Route path="/admin/blogs" element={<AdminBlogs />} />
          <Route path="/admin/book-summaries" element={<AdminBookSummaries />} />
          <Route path="/admin/books" element={<AdminBooks />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />
          <Route path="/admin/testimonials" element={<AdminTestimonials />} />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
